export const bodyContent = [
  {
    id: 0,
    heading: 'Live Music & Classes',
    paragraph:
      'Watch, learn, and taste as we host a variety of classes and workshops throughout the year. Our greenhouse and tasting room also serve as ideal venues for local music performers. Join us on Saturday evenings from 6pm until 8:30pm for captivating performances across various popular music genres. On Sundays from 2pm until 4pm, indulge in the soothing sounds of jazz. Sit back, relax, and enjoy one of our award-winning ciders or a local craft beverage while savoring our delectable small plates.',
    image:
      'https://i0.wp.com/www.theciderfarm.com/wp-content/uploads/2023/04/Helen-Anthony-at-TCF.jpeg?;ssl=1',
    link: 'https://www.theciderfarm.com/events',
    linkText: 'Event Schedule',
    class: 'livemusic',
  },
  {
    id: 1,
    heading: 'Happy Hour',
    paragraph:
      'Our patio and tasting room offer the ideal setting to unwind and catch up with friends and colleagues. Take advantage  of our Happy Hour pricing from 3pm to 6pm on weekdays, which includes $2 off our international award-winning ciders and selection of local craft beers. Sip on a cider, beer, or specialty cocktail while indulging in one of our delicious small plates.',
    image:
      'https://i0.wp.com/www.theciderfarm.com/wp-content/uploads/2022/04/Greenhouse-5.jpg?;ssl=1',
    link: 'https://www.theciderfarm.com/menu',
    linkText: 'See Menu',
    class: 'happyhour',
  },
  {
    id: 2,
    heading: 'Event Spaces',
    paragraph:
      'Our greenhouse space is a delightful venue for parties of 20 to 45 people. The three-season greenhouse has roll-up garage doors that can be opened on the sides providing a cheerful and breezy atmosphere that gives any gathering a festive tone. We also host parties inside the tasting room for groups up to 45 people. Whether it is a bridal or baby shower or a family or corporate event, check with us to see what food, beverage and venue options we can provide.',
    image:
      'https://i0.wp.com/www.theciderfarm.com/wp-content/uploads/2019/12/Tasting-Room-interior-Mar2019.jpg?;ssl=1',
    link: 'https://www.theciderfarm.com/contact',
    linkText: 'Learn More',
    class: 'eventspace',
  },
];
